// @flow
import { buildReducer } from '../lib/buildReducer'
import { omit } from 'lodash'
import { get, set } from 'dot-prop-immutable'
import type {
  EntityState,
  EntityMap,
  MergeAction,
  RemoveManyAction,
  RemoveAllAction,
  UpdateAction
} from './types'
import * as ActionTypes from './actionTypes'
export * from './actions'
export * from './selectors'
export * from './types'

const initialState = {}

const mergeWithExistingDomain = (
  domain: EntityMap<Object> = {},
  data: Object
): EntityMap<Object> => {
  return Object.keys(data).reduce((acc, id) => {
    return set(acc, id, existingData => ({
      ...existingData,
      ...data[id]
    }))
  }, domain)
}

const actions = {
  [ActionTypes.MERGE]: (
    state: EntityState,
    { payload }: MergeAction
  ): EntityState => {
    return Object.keys(payload).reduce((acc, domain) => {
      return {
        ...acc,
        [domain]: mergeWithExistingDomain(state[domain], payload[domain])
      }
    }, state)
  },
  [ActionTypes.REMOVE]: (
    state: EntityState,
    { payload }: RemoveManyAction
  ): EntityState => {
    const { domain, keys } = payload
    return {
      ...state,
      [domain]: omit(state[domain], keys)
    }
  },
  [ActionTypes.REMOVE_ALL]: (
    state: EntityState,
    { payload }: RemoveAllAction
  ): EntityState => {
    return omit(state, payload.domain)
  },
  [ActionTypes.RESET]: (): EntityState => {
    return initialState
  },
  [ActionTypes.UPDATE]: (
    state: EntityState,
    { payload }: UpdateAction
  ): EntityState => {
    const { domain, id, data } = payload
    const existing = get(state, `${domain}.${id}`) || {}
    //console.log('Update existing', existing, data)
    const merged = {
      ...existing,
      ...data
    }
    return set(state, `${domain}.${id}`, merged)
  }
}

export default buildReducer(initialState, actions)



// WEBPACK FOOTER //
// ./src/modules/entities/index.js